// PD Rally Placeholder
import axios from 'axios';

const BASE_URL_FAILED_AUTO_CHARGE_TRIGGER = '/app/failedAutoChargeTrigger';

export const createOrUpdateFailedAutoChargeConfig = async (oracleId, productIds = [], sources = [], failureAttemptIds = ['1']) => {
    const payload = {
        oracleId,
        productIds,
        sources,
        failureAttemptIds,
    };

    const { data } = await axios.post(`${BASE_URL_FAILED_AUTO_CHARGE_TRIGGER}`, payload, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });

    return data;
};

export const getFailedAutoChargeConfig = async (oracleId) => {
    const { data } = await axios.get(`${BASE_URL_FAILED_AUTO_CHARGE_TRIGGER}/${oracleId}`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });

    return data;
};
